import { useEffect, useState } from 'react';
import { useFilterParamsContext } from '../filter_main/model/filter_params';
import FilterCondition from './filter_condition.js';
import * as React from 'react';
import { ServiceBlock } from '../filter_mobile/ui/service_block';

const MAX_BLOCKS = 6;

export const PopularServiceTags = ({ filterParamsProperty, ...props }) => {
  const { filterParams } = useFilterParamsContext();
  const campServiceTags = filterParams[filterParamsProperty] ?? [];

  const [showAllServiceTags, setShowAllServiceTags] = useState(false);

  useEffect(() => {
    const $filterPopup = $('#filter-popup');
    $filterPopup.animate({ scrollTop: $filterPopup.scrollTop() + $(window).height() - 100 }, 400);
  }, [showAllServiceTags]);

  if (props.show_chosen && (props.value || []).length === 0) {
    return null;
  }

  const isChecked = (id) => {
    return (props.value || []).includes(String(id));
  };

  const tagsToRender = () => {
    if (props.counts) {
      return campServiceTags.filter((item) => isChecked(item.id) || props.counts[item.id] > 0);
    } else {
      return campServiceTags;
    }
  };

  const handleChange = (event) => {
    let newValue = [...(props.value || [])];

    if (event.target.checked) {
      newValue.push(event.target.value);
    } else {
      newValue = newValue.filter((v) => v != event.target.value);
    }

    return props.filter(props.condition_param, newValue.length === 0 ? false : newValue);
  };

  const onShowAllServiceTags = () => {
    setShowAllServiceTags(true);
    window.ymReachGoal('filter:sidebar:services-show-more-btn');
  };

  const popularServiceBlocks = () => {
    return tagsToRender().map((service_tag, i) => {
      if ((!props.show_chosen || isChecked(service_tag.id)) && i < MAX_BLOCKS) {
        return popularServiceBlock(service_tag, i);
      } else return null;
    });
  };

  const serviceBlocks = () => {
    return tagsToRender().map((serviceTag, i) => {
      if ((!props.show_chosen || isChecked(serviceTag.id)) && i >= MAX_BLOCKS) {
        return <ServiceBlock serviceTag={serviceTag} onChange={handleChange} isChecked={isChecked(serviceTag.id)} counts={props.counts} key={i} />;
      } else return null;
    });
  };

  const popularServiceBlock = (service_tag, i) => {
    return (
      <label
        className={`popular-services__tag ${isChecked(service_tag.id) ? 'popular-services__tag-checked' : ''}`}
        key={i}
      >
        <input
          className='hidden'
          type='checkbox'
          onChange={handleChange}
          value={service_tag.id}
          data-id={service_tag.id}
          checked={isChecked(service_tag.id)}
        />
        <div
          className='div-service-icon div-service-icon_full-width'
          style={{ backgroundImage: `url(${service_tag.icon})` }}
        />
        {service_tag.name}
        {props.counts && !isChecked(service_tag.id) && (
          <div className={'mdc-checkbox__label-count'}>{props.counts[service_tag.id] ?? 0}</div>
        )}
      </label>
    );
  };

  const moreButton = () => {
    return (
      <a role='button' className='popular-services__show-more m-t-16' onClick={onShowAllServiceTags}>
        Показать еще
      </a>
    );
  };

  const filteredTagsProperties = props.filtered_tags_properties;

  const tagsProperties = filteredTagsProperties && (
    <FilterCondition
      condition_name={''}
      condition_param={props.tags_param}
      filter={props.filter}
      enabled_ids={props.tags_enabled_ids}
      condition_items={props.tags_condition_items}
      filtered_all_categories={'true'}
    />
  );

  return (
    <div className='filter-row filter-row_no-border'>
      <div className='filter-row__title'>{props.service_name}</div>
      <div className='popular-services m-b-16'>{popularServiceBlocks()}</div>
      {!serviceBlocks().some((checked) => checked) || popularServiceBlocks().length <= MAX_BLOCKS || showAllServiceTags
        ? ''
        : moreButton()}
      {serviceBlocks().some((checked) => checked) && showAllServiceTags ? (
        <div className='filter-row__title_small m-b-8 m-t-8'>другие услуги:</div>
      ) : (
        ''
      )}
      {showAllServiceTags ? tagsProperties : ''}
      {showAllServiceTags ? serviceBlocks() : ''}
    </div>
  );
};
